import { Host } from '../../index'

const AdminSysteminfo = `${Host}store/index/system_info`
const AdminLoginConfig = `${Host}store/publics/login_config`
const AdminPublicsLogin = `${Host}store/publics/login`
const AdminPublicsLogout = `${Host}store/publics/logout`
const AdminPublicsRefresh = `${Host}store/publics/refresh`
const AdminPublicsCaptcha = `${Host}store/publics/captcha`

const AdminMenus = `${Host}store/menu/menus`

const AdminAttachmentList = `${Host}store/attachment/index`
const AdminAttachmentUpload = `${Host}store/attachment/upload`
const AdminAttachmentDirList = `${Host}store/attachment/list_dir`
const AdminAttachmentDirAdd = `${Host}store/attachment/add_dir`
const AdminAttachmentDirEdit = `${Host}store/attachment/edit_dir`
const AdminAttachmentDirDel = `${Host}store/attachment/del_dir`

const AdminAjaxSelectList = `${Host}store/ajax/get_select_list`
const AdminAjaxLevelData = `${Host}store/ajax/get_level_data`

export default {
    AdminSysteminfo,

    AdminLoginConfig,

    AdminMenus,

    AdminPublicsLogin,
    AdminPublicsLogout,
    AdminPublicsRefresh,
    AdminPublicsCaptcha,

    AdminAttachmentDirList,
    AdminAttachmentDirAdd,
    AdminAttachmentDirEdit,
    AdminAttachmentDirDel,
    AdminAttachmentList,
    AdminAttachmentUpload,

    AdminAjaxSelectList,
    AdminAjaxLevelData
}
